import { PortableText, PortableTextBlock } from "@portabletext/react";
import styled from "styled-components";
import linkIconUrl from "@assets/icons/link.svg";
import { ReactNode } from "react";

interface Props {
  copy?: PortableTextBlock[];
  children?: ReactNode;
}

export const Container = styled.div`
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-normal);
  line-height: 24px;
  letter-spacing: var(--letter-spacing-normal);

  a {
    color: var(--text-link);
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-xl);
    text-decoration-line: underline;
    display: inline-flex;
    align-items: center;

    &::after {
      content: "";
      display: inline-block;
      margin-left: 8px;
      width: 16px;
      height: 16px;
      background-image: url(${linkIconUrl});
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  strong {
    font-weight: var(--font-weight-bold);
  }

  ul {
    padding-left: 24px;
  }
`;

const RichText = ({ copy, children }: Props) => {
  return (
    <Container>
      {copy && <PortableText value={copy} />}
      {children}
    </Container>
  );
};

export default RichText;
